import {
  ArrowSyncFilled,
  ClockAlarmFilled,
  ArrowUpFilled,
  ArrowDownFilled,
  ChevronLeftFilled,
  ChevronRightFilled,
  ChevronDownFilled,
  DismissCircleFilled,
  ChatFilled,
  DataBarVerticalFilled,
  ProhibitedFilled,
  CheckmarkFilled,
  DismissFilled,
  ArrowSwapFilled,
  ChevronDoubleRightFilled,
  EditFilled,
  TrophyFilled,
  CalendarLtrFilled,
  ArrowPreviousFilled,
  PeopleFilled,
  QuestionCircle16Regular,
  DismissCircle20Regular,
  ArrowSortFilled,
  InfoFilled,
  InfoRegular,
  PersonRunningFilled,
  ColumnArrowRightFilled,
  ChevronUpFilled,
  PersonArrowRight20Filled,
  TextBulletListSquareFilled,
  LockClosedFilled,
  LockOpenFilled,
  Warning20Filled,
  SearchFilled,
  Share20Filled,
  DataTrendingFilled,
  DataLineFilled,
  SportSoccerFilled,
  StarFilled,
  StarRegular,
  StarHalfFilled,
  ThumbDislikeFilled,
  Eye20Filled,
  ContentSettings20Filled,
  CheckmarkCircle20Filled,
  ChevronCircleUpFilled,
  ChevronCircleDownFilled,
  DoorArrowRight20Regular,
  SignOut24Filled,
  Person24Filled,
  Open16Filled,
  LineHorizontal320Filled,
  MoreHorizontal16Filled,
  Person16Filled,
  CheckmarkCircle24Filled,
  PremiumFilled,
  Delete20Filled,
  ArrowHookDownRight24Filled,
  ContactCard20Filled,
  PersonStar24Filled,
  CurrencyDollarEuro24Filled,
  NumberSymbolSquare20Filled,
  ArrowUpRight24Filled,
  ThumbLikeFilled,
  BuildingBankFilled,
  MathSymbolsFilled,
  ArrowRightFilled,
  BookmarkRegular,
  BookmarkFilled,
  SendFilled,
  PersonAddFilled,
  PersonArrowBackFilled,
  ImageAddFilled,
  ArrowExpandFilled,
  FilterFilled,
  PenFilled,
  SparkleFilled,
  PeopleTeamFilled,
  Settings20Filled,
  SpinnerIosFilled,
  Toolbox20Filled,
  News16Filled
} from '@fluentui/react-icons';

import React, { forwardRef } from 'react';
import { TwitterIcon, WhatsAppIcon } from './misc';
import Tooltip from '../tooltip';

export type IconType = keyof typeof icons;

export const icons = {
  Avatar: Person16Filled,
  Alarm: ClockAlarmFilled,
  ArrowDownward: ArrowDownFilled,
  ArrowDropDown: ArrowDownFilled,
  ArrowDropUp: ArrowUpFilled,
  ArrowSortFilled,
  ArrowForwardIos: ChevronRightFilled,
  ArrowUpward: ArrowUpFilled,
  BarChart: DataBarVerticalFilled,
  Block: ProhibitedFilled,
  Cached: ArrowSyncFilled,
  Calendar: CalendarLtrFilled,
  Cancel: DismissCircleFilled,
  Check: CheckmarkFilled,
  CheckCircle: CheckmarkCircle24Filled,
  ChatFilled,
  ChevronDown: ChevronDownFilled,
  ChevronUp: ChevronUpFilled,
  ChevronLeft: ChevronLeftFilled,
  ChevronRight: ChevronRightFilled,
  CompareArrows: ArrowSwapFilled,
  Close: DismissFilled,
  PersonRunningFilled,
  DoubleArrow: ChevronDoubleRightFilled,
  Edit: EditFilled,
  External: DoorArrowRight20Regular,
  ContentSettings20Filled,
  FirstPage: ArrowPreviousFilled,
  Group: PeopleFilled,
  HelpOutline: QuestionCircle16Regular,
  HighlightOff: DismissCircle20Regular,
  InfoFilled,
  Input: ColumnArrowRightFilled,
  LabelImportant: PersonArrowRight20Filled,
  LineGraph: DataLineFilled,
  ListAlt: TextBulletListSquareFilled,
  Lock: LockClosedFilled,
  LockOpen: LockOpenFilled,
  Person: Person24Filled,
  Report: Warning20Filled,
  Search: SearchFilled,
  SignOut: SignOut24Filled,
  Share: Share20Filled,
  ShowChart: DataTrendingFilled,
  SoccerBall: SportSoccerFilled,
  Star: StarFilled,
  StarBorder: StarRegular,
  StarHalf: StarHalfFilled,
  Tick: CheckmarkCircle20Filled,
  ThumbDown: ThumbDislikeFilled,
  Trophy: TrophyFilled,
  Twitter: TwitterIcon,
  Visibility: Eye20Filled,
  Warning: Warning20Filled,
  WhatsApp: WhatsAppIcon,
  ChevronCircleUpFilled,
  ChevronCircleDownFilled,
  ExternalLink: Open16Filled,
  Hamburger: LineHorizontal320Filled,
  Ellipsis: MoreHorizontal16Filled,
  Premium: PremiumFilled,
  ArrowUpRightFilled: ArrowUpRight24Filled,
  Delete: Delete20Filled,
  ArrowDownRightFilled: ArrowHookDownRight24Filled,
  ContactCard: ContactCard20Filled,
  PersonStar: PersonStar24Filled,
  Currency: CurrencyDollarEuro24Filled,
  Number: NumberSymbolSquare20Filled,
  ThumbsUp: ThumbLikeFilled,
  ThumbsDown: ThumbDislikeFilled,
  Bank: BuildingBankFilled,
  MathSymbolsFilled,
  ArrowRight: ArrowRightFilled,
  BookmarkRegular,
  BookmarkFilled,
  Send: SendFilled,
  PlayerIn: PersonAddFilled,
  PlayerOut: PersonArrowBackFilled,
  ImageAddFilled,
  ArrowExpandFilled,
  FilterFilled,
  PenFilled,
  SparkleFilled,
  PeopleTeamFilled,
  Settings: Settings20Filled,
  Spinner: SpinnerIosFilled,
  InfoRegular,
  Content: ContentSettings20Filled,
  Toolbox: Toolbox20Filled,
  News: News16Filled
};

type IconProps = {
  name: IconType;
  title?: string;
  [x: string]: any;
};

const Icon = forwardRef<any, IconProps>(
  ({ name, title = '', ...rest }, ref) => {
    const IconComponent = icons[name] as React.ComponentType<any>;
    if (title) {
      return (
        <Tooltip variant="dark" title={title}>
          <IconComponent ref={ref} {...rest} />
        </Tooltip>
      );
    } else {
      return <IconComponent ref={ref} {...rest} />;
    }
  }
);

Icon.displayName = 'Icon';
export default Icon;
